// locales/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 1. 使用 Webpack 的 require.context 动态导入所有语言模块文件
const localesContext = require.context('./', true, /\.json$/)

// 2. 构建 messages 对象
const messages = {}

localesContext.keys().forEach(path => {
    // 提取语言代码，例如从 './en/common.json' 提取 'en'
    const pathInfoArray = path.split('/')
    const langCode = pathInfoArray[1]
    const fileName = pathInfoArray[2].replace('.json', '')

    // 获取模块内容
    const moduleContent = localesContext(path)

    if (!messages[langCode]) {
        messages[langCode] = {}
    }

    // 合并模块内容
    messages[langCode][fileName] = moduleContent
})

const localeLanguages = 'es'
// 3. 创建 i18n 实例
const i18n = new VueI18n({
    locale: localeLanguages, // 默认语言
    fallbackLocale: 'en', // 回退语言
    messages: messages,
    silentTranslationWarn: true, // 可选：静默翻译警告
})

// 创建可以直接引用的 t 函数
export const t = (key, params) => {
    return i18n.t(key, params)
}

export default i18n